'use client'

import { useEffect, useState } from 'react';
import styles from "../../partials/ua.module.scss";
import ApiUtils from '@/utils/ApiUtils';
import { getCookie, setCookie } from 'cookies-next';
import Button from '../button/Button';
import GoogleLoginPlugin from './GoogleLoginPlugin';
import useEventListener from './EventListener';

export const SITE_COOKIE_NAME = "_ua_vid"
const CONSENT_COOKIE_NAME = "_ua_cookies"

export default function SessionManager(props) {
  
  const site = props.site

  const [consent, setConsent] = useState()
  const [loggedIn, setLoggedIn] = useState(false)
  const [loginChecked, setLoginChecked] = useState(false)

  useEventListener("session_checked", event => {
    setLoggedIn(event.detail)
    setLoginChecked(true)
  })
  
  useEffect(() => {
    ApiUtils.checkAuth()
    if (!site.cookie_banner?.script_top && !site.cookie_banner?.script_bottom) {
      if (site.vid) {
        setCookie(SITE_COOKIE_NAME, site.vid, {
          path: '/', secure: true
        })
      }
      const consentData = getCookie(CONSENT_COOKIE_NAME) ? JSON.parse(getCookie(CONSENT_COOKIE_NAME)) : {}
      setConsent(consentData)
    } else {
      setConsent({ status: -1 })
    }
  }, [])
  
  const onAccept = () => {
    setStatus(1)
  }

  const onDecline = () => {
    setStatus(-1)
  }

  const setStatus = (value) => {
    const data = { status: value }
    setConsent(data)
    setCookie(CONSENT_COOKIE_NAME, JSON.stringify(data))
  }

  if (!consent) return <></>

  if ((consent.status == 1 || consent.status == -1) && loginChecked && !loggedIn) {
    return <>
      { !site.isBot && site.api_keys.facebook_app_id &&
      <script id="facebook-jssdk" src="//connect.facebook.net/en_US/sdk.js" async></script>
      }
      { !site.isBot && site.api_keys.g_oauth_client_id &&
      <script src="https://accounts.google.com/gsi/client" async></script>
      }
      <GoogleLoginPlugin site={site}></GoogleLoginPlugin>
    </>
  }

  if (consent.status == -1 || consent.status == 1) return <></>

  return <div className={styles.cb}>
    <div>
      <div className="flex-col flex-stretch" dangerouslySetInnerHTML={{ __html: site.cookie_banner.message }}></div>
      <div className="flex-col">
        <div className={ styles.cbb }>
          <div className="flex-col">
            <Button theme={['primary']} label={site.cookie_banner.accept_all} onClick={e => onAccept()}></Button>
          </div>
          <div className="flex-col">
            <Button theme={['line']} label={ site.cookie_banner.accept_essentials } onClick={e => onDecline()}></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
}